import SetupCalendarIcon from "~vue/icons/SetupCalendarIcon.vue";
import SetupProfileIcon from "~vue/icons/SetupProfileIcon.vue";
import type { SetupStepId } from "~vue/ProfileSetup/types";
import type { Component } from "vue";

/**
 * Keep labels, actions, and completion state server-owned. Calendar and profile use custom icons because
 * Bootstrap alternatives do not match the intended symbols.
 */
export const SETUP_SECTION_ICONS: Record<SetupStepId, string | Component> = {
    identity: "bi-person",
    calendar: SetupCalendarIcon,
    perspective: "bi-circle",
    publish: SetupProfileIcon,
};
